export default function InstructorHomePage() {
  return (
    <div className="mx-auto max-w-lg space-y-3 rounded-xl border border-border/70 bg-muted/10 p-6 text-center">
      <h1 className="text-lg font-semibold tracking-tight">Instructor portal</h1>
      <p className="text-sm text-muted-foreground">
        Open the attendance link your coordinator shared. It looks like{' '}
        <span className="font-mono text-xs text-foreground">/instructor/forms/…/attendance</span>.
      </p>
      <p className="text-xs text-muted-foreground">
        Need a link? Ask your program administrator from the form&apos;s detail page (Copy instructor link).
      </p>
    </div>
  );
}
